const UTM_PREFIX = 'utm_';
const INITIAL_UTM_PREFIX = 'initial_utm_';

const getUtmDataWithPrefixFromObject = (obj: { [key: string]: string } | undefined, prefix: string) => {
    const utmData: { [key: string]: string } = {};
    if (!obj) return utmData;

    for (const param in obj) {
        if (!param.startsWith(prefix)) continue;

        const value = obj[param];
        if (!value) continue;

        utmData[param] = value;
    }

    return utmData;
};

/**
 * Gets UTM data from an object, typically URL parameters.
 */
export const getUtmDataFromObject = (obj: { [key: string]: string } | undefined) =>
    getUtmDataWithPrefixFromObject(obj, UTM_PREFIX);

/**
 * Gets initial UTM data from an object.
 */
export const getInitialUtmDataFromObject = (obj: { [key: string]: string } | undefined) =>
    getUtmDataWithPrefixFromObject(obj, INITIAL_UTM_PREFIX);

/**
 * Converts standard UTM parameters (`utm_source`) to initial UTM parameters (`initial_utm_source`).
 */
export const convertUtmDataToInitialUtmData = (utmData: { [key: string]: string } | undefined) => {
    const initialUtmData: { [key: string]: string } = {};

    if (!utmData) return initialUtmData;

    for (const key in utmData) {
        if (!key.startsWith(UTM_PREFIX)) continue;

        const value = utmData[key];
        if (!value) continue;

        initialUtmData[`${INITIAL_UTM_PREFIX}${key.substring(UTM_PREFIX.length)}`] = value;
    }

    return initialUtmData;
};
